import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const UPDATE_ACCOUNT_DELIVERY_DRIVER_DUTY_STATUS = gql`
    mutation UpdateAccountDeliveryDriverDutyStatus($driverId: Long!, $isOnDuty: Boolean!) {
        updateAccountDeliveryDriverDutyStatus(driverId: $driverId, isOnDuty: $isOnDuty)
    }
`;

export interface UpdateAccountDeliveryDriverDutyStatusResponse {
    updateAccountDeliveryDriverDutyStatus: boolean;
}

export interface UpdateAccountDeliveryDriverDutyStatusVariables {
    driverId: number;
    isOnDuty: boolean;
}

export const updateAccountDeliveryDriverDutyStatus = async (driverId: number, isOnDuty: boolean): Promise<boolean> => {
    const { data } = await client.mutate<UpdateAccountDeliveryDriverDutyStatusResponse, UpdateAccountDeliveryDriverDutyStatusVariables>({
        mutation: UPDATE_ACCOUNT_DELIVERY_DRIVER_DUTY_STATUS,
        variables: { driverId, isOnDuty }
    });
    
    return data!.updateAccountDeliveryDriverDutyStatus;
}; 